// extracted by mini-css-extract-plugin
export default {"CreateAccount_form-item-horizontal":"CreateAccount_CreateAccount_form-item-horizontal__wHLRf"};